import React, { useState, ReactNode } from 'react'
import './Dropdown.css'

type DropdownProps<T> = {
  options: T[]
  selectedOption: T
  onOptionChange: (option: T) => void
  renderOption: (option: T) => ReactNode
  renderSelectedOption: (option: T) => ReactNode
}

const Dropdown = <T,>({
  options,
  selectedOption,
  onOptionChange,
  renderOption,
  renderSelectedOption,
}: DropdownProps<T>): JSX.Element => {
  const [dropdownOpen, setDropdownOpen] = useState(false)

  const handleDropdownToggle = (): void => {
    setDropdownOpen(!dropdownOpen)
  }

  const handleOptionSelect = (option: T): void => {
    onOptionChange(option)
    setDropdownOpen(false)
  }

  return (
    <div className="custom-dropdown">
      <button className="custom-dropdown-button" onClick={handleDropdownToggle}>
        <span className="custom-dropdown-selected-text">
          {renderSelectedOption(selectedOption)}
        </span>
        <i className="fa fa-caret-down custom-dropdown-caret-icon"></i>
      </button>
      {dropdownOpen && (
        <ul className="custom-dropdown-menu">
          {options.map((option) => (
            <li
              key={JSON.stringify(option)}
              onClick={() => handleOptionSelect(option)}
            >
              <div className="custom-dropdown-item">{renderOption(option)}</div>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default Dropdown
